import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { Typography, Grid } from "@material-ui/core";
import Numberformat from "../../atoms/Numberformat";
import IBANFormat from "../../atoms/IBANFormat";
import SepaQRCode from "../SepaQRcode";
import Table from "@material-ui/core/Table";
import { TableBody, TableCell, TableRow } from "@material-ui/core";

const styles = theme => ({
  refinput: {
    fontSize: 20,
    width: "100%",
    maxWidth: "100%",
    marginBotton: theme.spacing(1)
  },
  qrcode: {
    width: "100%",
    height: "auto"
  }
});

class PaymentInfoEUR extends Component {
  render() {
    //const { classes } = this.props;
    const { currency, OrderNumber } = this.props.order;
    const { sum, token } = this.props.order.display;
    const {
      bank_name,
      swift,
      bank_address,
      name,
      bic,
      iban
    } = this.props.order.toAccount;
    return (
      <div>
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <Typography gutterBottom>
              Send <Numberformat value={sum} />
              &nbsp;{currency} and get <Numberformat value={token} digits={6} />
              &nbsp;CRWD&nbsp;Token to your Wallet
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <SepaQRCode
              name={name}
              bic={bic}
              iban={iban}
              amount={sum}
              remittancereference={OrderNumber}
              size={128}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Bank Name</TableCell>
                  <TableCell>{bank_name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>IBAN</TableCell>
                  <TableCell>
                    <IBANFormat iban={iban} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>SWIFT/BIC</TableCell>
                  <TableCell>
                    {swift}
                    {swift !== bic ? " / " + bic : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Bank Address</TableCell>
                  <TableCell>{bank_address}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Reference</TableCell>
                  <TableCell>{OrderNumber}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Recipient</TableCell>
                  <TableCell>{name}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </div>
    );
  }
}

PaymentInfoEUR.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PaymentInfoEUR);
